import React from "react";

const AuthFormSection = ({ type, isActive, step, children }) => {
  const className = `form-container ${type}`;
  const contentClassName = `containerContentForm ${
    (type === "sign-up" && !isActive) || (type === "sign-in" && isActive) ? "active" : ""
  }`;

  // Déterminer le contenu à afficher
  const getContent = () => {
    if (step === "form") return children.form;
    if (step === "2fa") return children.twofa;
    if (step === "forgotPassword") return children.forgotPassword;
    if (step === "forgotPasswordCode") return children.forgotPasswordCode;
    if (step === "forgotPasswordReset") return children.forgotPasswordReset;
    return children.form;
  };

  return (
    <div className={className}>
      <form>
        <div className={contentClassName}>
          {getContent()}
        </div>
      </form>
    </div>
  );
};

export default AuthFormSection;
